import { connect } from 'react-redux';

import * as sessionActions from '@opendoor/shared-fe/build/store/session/actions';
import * as sessionSelectors from '@opendoor/shared-fe/build/store/session/selectors';
import { createSelector } from 'reselect';

import { IRequestStatus } from '../account/RequestStatus';

export interface ResetPasswordProps {
  loggedIn: boolean;
  resetPasswordRequestStatus: IRequestStatus;
  serverLoginRedirect: string | undefined;
  email: string;
  hasGeneratedPassword: boolean;
  isNewHuman: boolean;
  requestPasswordReset: (email: string) => void;
}

const mapStateToProps = createSelector(
  [
    sessionSelectors.loggedIn,
    sessionSelectors.resetPasswordRequestStatus,
    sessionSelectors.serverLoginRedirect,
    sessionSelectors.email,
    sessionSelectors.hasGeneratedPassword,
    sessionSelectors.isNewHuman,
  ],
  (
    loggedIn: boolean,
    resetPasswordRequestStatus: IRequestStatus,
    serverLoginRedirect: string | undefined,
    email: string,
    hasGeneratedPassword: boolean,
    isNewHuman: boolean,
  ) => ({
    loggedIn,
    resetPasswordRequestStatus,
    serverLoginRedirect,
    email,
    hasGeneratedPassword,
    isNewHuman,
  }),
);

const mapDispatchToProps = (dispatch: any) => {
  return {
    requestPasswordReset: (email: string) => {
      dispatch(sessionActions.requestPasswordReset(email));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
